import { postUserChangePermission } from '@api';
import { updateCustomerUser } from '../../customers/_id/users/actions';
import { updateUser } from '../all/actions';
import { UpdateUserReferenceRequest } from '@types';
import { updateUserReferences } from '../_idMap/actions';

import { AMPLITUDE_EVENT, createLogSagaWithFn } from '@sonar-software/sonar-analytics';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreUsersByIdPostSlice = createPostAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSagaWithFn((action) => {
				const { isLocked, isReadOnly } = action.data;

				if (isReadOnly !== undefined) {
					return {
						data: { isReadOnly },
						id: AMPLITUDE_EVENT.USER_PERMISSIONS_UPDATED
					};
				} else if (isLocked !== undefined) {
					return {
						data: { isLocked },
						id: AMPLITUDE_EVENT.USER_STATUS_UPDATED
					};
				}

				return undefined;
			}),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			updateCustomerUser,
			updateUser,
			(request) => {
				const update: UpdateUserReferenceRequest = {
					userId: request.userId
				};

				if (request.isLocked !== undefined) {
					update.isLocked = request.isLocked;
				}

				if (request.isReadOnly !== undefined) {
					update.isReadOnly = request.isReadOnly;
				}

				return updateUserReferences([ update ]);
			}
		]
	},
	name: 'CoreUsersById',
	receive: false,
	request: true,
	requestHandler: postUserChangePermission,
	retainDataOnRequest: false
});
